/* ==========================================================================
   Matthews Cleaning Co. — Homepage JS
   Handles: dispatch countdown, qty steppers, AJAX add-to-cart, trade form
   ========================================================================== */

(function () {
  'use strict';

  /* --- Dispatch countdown (2pm Sydney time cutoff, weekend-aware, handles daylight saving) --- */
  function initCountdown() {
    var el = document.getElementById('mcc-countdown');
    if (!el) return;

    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour') || '14', 10);
    function tick() {
      // Current wall-clock time in Sydney, so AEST and AEDT are both handled
      var now = new Date();
      var syd = new Date(now.toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
      var cutoff = new Date(syd.getTime());
      cutoff.setHours(cutoffHour, 0, 0, 0);
      var nextDay = false;

      if (syd >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
        nextDay = true;
      }
      // No dispatch on weekends: roll forward to Monday
      while (cutoff.getDay() === 0 || cutoff.getDay() === 6) {
        cutoff.setDate(cutoff.getDate() + 1);
        nextDay = true;
      }

      var diff = cutoff.getTime() - syd.getTime();
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var prefix = nextDay ? 'Next dispatch cutoff in ' : 'Same-day dispatch in ';
      el.innerHTML = prefix + '<strong>' + h + 'h ' + m + 'm</strong>';
    }

    tick();
    setInterval(tick, 30000);
  }

  /* --- Qty steppers on product cards --- */
  function initQtySteppers() {
    document.querySelectorAll('.mcc-qty-group').forEach(function (group) {
      var nEl = group.querySelector('.mcc-qty-n');
      var btns = group.querySelectorAll('.mcc-qty-btn');
      if (!nEl || btns.length !== 2) return;

      // Parse initial value safely
      var currentVal = parseInt(nEl.textContent.trim(), 10) || 1;

      btns[0].addEventListener('click', function (e) {
        e.preventDefault();
        currentVal = Math.max(1, currentVal - 1);
        nEl.textContent = currentVal;
      });
      btns[1].addEventListener('click', function (e) {
        e.preventDefault();
        currentVal = Math.min(999, currentVal + 1);
        nEl.textContent = currentVal;
      });
    });
  }

  /* --- AJAX Add-to-cart (Shopify cart API) --- */
  function initAddToCart() {
    document.querySelectorAll('.mcc-add-cart').forEach(function (btn) {
      // Prevent double-binding
      if (btn.hasAttribute('data-bound')) return;
      btn.setAttribute('data-bound', 'true');

      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        // Always default to quantity 1 unless a qty selector exists
        var quantity = 1;
        var card = btn.closest('.mcc-prod');
        if (card) {
          var qtyEl = card.querySelector('.mcc-qty-n');
          if (qtyEl) {
            var parsed = parseInt(qtyEl.textContent.trim(), 10);
            quantity = Math.max(1, parsed || 1);
          }
        }

        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding…';

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function (json) {
            btn.textContent = 'Added ✓';
            // Open the slide-out cart when the theme has one (7 Oct 2026)
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && json && json.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(json);
              setTimeout(function () {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 1500);
              return;
            }
            // Otherwise go to the cart page after a brief delay
            setTimeout(function () {
              window.location.href = '/cart';
            }, 600);
          })
          .catch(function () {
            btn.textContent = 'Failed';
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = originalText;
            }, 2000);
          });
      });
    });
  }

  /* --- Trade account form (posts to Shopify /contact endpoint) --- */
  function initTradeForm() {
    var form = document.getElementById('mcc-trade-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // Default behaviour is fine — Shopify /contact will redirect with success param.
      // We just block the default if somehow no action is set.
      if (!form.getAttribute('action')) {
        e.preventDefault();
      }
    });
  }

  /* --- Init on DOM ready --- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initCountdown();
    initQtySteppers();
    initAddToCart();
    initTradeForm();
  });
})();
